import { l, Icon } from '@manychat/manyui'

import { AiIntentTrigger } from 'apps/aiIntents/interfaces/interfaces'
import { ConverterRule } from 'common/builder/components/chart/FlowChart/lib/types'
import {
  FlowChartTrigger,
  FlowChartTriggerIconType,
} from 'common/builder/components/chart/FlowChart/types/FlowChartTrigger'
import { getTriggerConfig } from 'common/builder/utils/getTriggerConfig'
import { isTriggerInteractive } from 'common/builder/utils/isTriggerInteractive'
import { TriggerType } from 'common/flow/constants/TriggerType'
import { IFlowTrigger } from 'common/flow/flowInterfaces'

export const AiIntentGenericTriggerConverterRule: ConverterRule<IFlowTrigger, FlowChartTrigger> = {
  predicate: (entity: IFlowTrigger) => entity?.triggerType === TriggerType.AI_INTENT,
  convert: (entity: AiIntentTrigger) => {
    const triggerConfig = getTriggerConfig(entity)

    const trigger: FlowChartTrigger = {
      id: entity.triggerId,
      icon: {
        type: FlowChartTriggerIconType.ICON,
        icon: triggerConfig?.icon || null,
      },
      title: l.getString(triggerConfig?.description) || l.translate('Empty'),
      subtitle: [entity.caption],
      subtitleIcon: Icon.AiFilled,

      isActive: entity.enabled,
      isInteractive: isTriggerInteractive(entity),
    }

    return trigger
  },
}
